import { IMoveLineProps } from './MoveLine.types';
import { useMoveLineStyles } from './MoveLine.styles';
import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { useCart } from '../../../../../contexts/CartContext/CartContext.hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { useLineEdit } from '../../../../../contexts/LineEditContext/LineEditContext.hooks';

const MoveLine = (props: IMoveLineProps) => {
    const styles = useMoveLineStyles();

    const { cart } = useCart();

    const { HandleMoveLine } = useLineEdit();

    return (
        <div className={styles.root}>
            <Menu>
                <MenuTrigger disableButtonEnhancement>
                    <FontAwesomeIcon icon={faCaretDown} className={styles.menuButton} />
                </MenuTrigger>

                <MenuPopover>
                    <MenuList>
                        {cart.lineItems.map(
                            (item) =>
                                item.lineNumber !== props.lineNumber && (
                                    <MenuItem
                                        key={item.lineNumber}
                                        onClick={() =>
                                            HandleMoveLine(props.lineNumber, item.lineNumber)
                                        }
                                    >
                                        Move to Line {item.lineNumber}
                                    </MenuItem>
                                )
                        )}
                    </MenuList>
                </MenuPopover>
            </Menu>
        </div>
    );
};

export default MoveLine;
